import type { CopyResult } from '../types';

export async function copyText(text: string, documentRef: Document = document): Promise<CopyResult> {
  if (!text) {
    return { ok: false, method: 'none' };
  }

  if (globalThis.navigator?.clipboard?.writeText) {
    try {
      await globalThis.navigator.clipboard.writeText(text);
      return { ok: true, method: 'clipboard' };
    } catch {
      // 继续尝试兼容回退逻辑
    }
  }

  if (!documentRef.body || typeof documentRef.execCommand !== 'function') {
    return { ok: false, method: 'none' };
  }

  const hiddenTextarea = documentRef.createElement('textarea');
  hiddenTextarea.value = text;
  hiddenTextarea.setAttribute('readonly', 'true');
  hiddenTextarea.setAttribute('aria-hidden', 'true');
  hiddenTextarea.style.position = 'fixed';
  hiddenTextarea.style.top = '0';
  hiddenTextarea.style.left = '-9999px';
  hiddenTextarea.style.opacity = '0';

  documentRef.body.append(hiddenTextarea);
  hiddenTextarea.focus();
  hiddenTextarea.select();

  const copied = documentRef.execCommand('copy');
  hiddenTextarea.remove();

  return copied
    ? { ok: true, method: 'execCommand' }
    : { ok: false, method: 'none' };
}
